<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>

          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="showDialog(true)"
            v-show="hasCreateAuth"
            style="margin-bottom: 10px"
            >{{$t("button.uploadImg")}}</el-button
          >
          <el-row :gutter="24" class="PicList">
            <el-col :md="4" :sm="6" :xs="12" v-for="item in picList">
              <div class="block">
                <el-button
                  type="primary"
                  circle
                  icon="el-icon-edit"
                  v-show="hasUpdateAuth"
                  @click="showEditDialog(true, item.id)"
                >
                </el-button>
                <template>
                  <el-popconfirm
                    :confirmButtonText="$t('button.delete')"
                    :cancelButtonText="$t('button.cancel')"
                    :title="$t('title.confirmDelete')"
                    v-show="hasDeleteAuth"
                    @confirm="deleteImage(item.id)"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      circle
                      icon="el-icon-delete"
                    >
                    </el-button>
                  </el-popconfirm>
                </template>
                <el-image
                  style="width: 100%; height: 100px;padding:20px 3px"
                  :src="item.imageUrl"
                  fit="contain"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <span class="demonstration">{{ item.title }}</span>
              </div>
            </el-col>
          </el-row>
          <el-pagination
            background
            :page-size="pagination.pageSize"
            :page-sizes="[12, 24, 36]"
            :current-page.sync="pagination.current"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
             layout="prev, pager, next,sizes"
            :total="pagination.totalPage"
            style="text-align: center; margin-top: 10px"
          >
          </el-pagination>
        </el-main>
      </el-scrollbar>
    </el-container>

    <el-dialog
      ref="addRef"
      :refForm="'airFormAdd'"
      :title="(dialogTitle = $t('button.uploadImg'))"
      :imageForm="imageForm"
      :dialogAddClient="dialogAddClient"
      :subButtonAuth="hasCreateAuth"
      :isAdd="(isAdd = true)"
      :brandInfo="brandInfo"
      @onSubBtn="add"
      @dialogVisibleEvent="showDialog"
    >
    </el-dialog>
    <el-dialog
      ref="editRef"
      :refForm="'airFormEdit'"
      :title="(dialogTitle = $t('button.uploadImg'))"
      :imageForm="imageForm"
      :dialogAddClient="dialogEditClient"
      :subButtonAuth="hasCreateAuth"
      :isAdd="(isAdd = false)"
      :brandInfo="brandInfo"
      @onSubBtn="update"
      @dialogVisibleEvent="showEditDialog"
    >
    </el-dialog>


  </div>
</template>

<script>
import {
  authOperationCheck,
  addImage,
  getDeviceImages,
  updateImage,
  deleteImage,
  getDeviceImageById,
  getBrandInfos,
} from "../../api/api";
import { mapState } from "vuex";
import uploadImageComponent from "../../components/content/maintabber/UpLoadImage";

export default {
  name: "index",
  components: {
    "el-dialog": uploadImageComponent,
  },
  data() {
    return {
      dialogAddClient: false,
      dialogEditClient: false,
      hasUpdateAuth: false,
      hasDeleteAuth: false,
      hasCreateAuth: false,
      imageForm: {
        name: "",
        file: "",
        id: "",
        imageUrl: "",
        brandCode:"",
      },
      picList: [],
      form: {},
      brandInfo:{},
      pagination: {
        current: 1,
        pageSize: 12,
        totalPage: 0,
      },
    };
  },
  async mounted() {
    this.getBrandInfos();
    this.getDeviceImages();
  },
  created: function () {
    this.authOperation("DeviceImage");
    
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
    navselected: (state) => state.adminleftnavnum,
  }),

  methods: {
     authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
    },
    showDialog(visible) {
      this.dialogAddClient = visible;
      if (visible) {
        this.imageForm = {
          name: "",
          file: "",
          imageUrl: "",
          id: "",
          brandCode:"",
        };
      
        if (this.$refs.addRef.$refs.airFormAdd != undefined) {
          this.$refs.addRef.$refs.airFormAdd.resetFields();
        }
        let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
        this.$set(this.imageForm, "brandCode", brand);
      }
    },
    showEditDialog(visible, id) {
      this.dialogEditClient = visible;
      if (visible) {
        this.getDeviceImageById(id);
        if (this.$refs.editRef.$refs.airFormAdd != undefined) {
          this.$refs.editRef.$refs.airFormAdd.resetFields();
        }
      } else {
        var that=this;
        this.imageForm = {
          name: "",
          file: "",
          imageUrl: "",
          id: "",
          brandCode:"",
        };
        if (this.$refs.editRef.$refs.airFormAdd != undefined) {
          this.$refs.editRef.$refs.airFormAdd.resetFields();
        }
      }
    },
    getDeviceImageById(e) {
      let that = this;
      let data = { id: e };
      getDeviceImageById(data).then((res) => {
        console.log(res);
        that.imageForm.name = res.result.title;
        that.imageForm.imageUrl =res.result.imageUrl;
        // "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg";
        that.imageForm.id = res.result.id;
        that.imageForm.brandCode=res.result.brandCode;
      });
    },
    getDeviceImages() {
      let that = this;
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      let postData = {
        SkipCount: skipcount,
        MaxResultCount: this.pagination.pageSize,
      };
      getDeviceImages(postData).then((res) => {
        console.log(res);
        let data = res.result.items;
        this.pagination.totalPage = res.result.totalCount;
        that.picList = data;
      });
    },
    add() {
      let that = this;
      this.headers = {
        "Content-Type": "multipart/form-data",
      };
      const formData = new FormData();

      formData.append("name", that.imageForm.name);
      formData.append("file", that.imageForm.file);
      formData.append("brandCode",that.imageForm.brandCode);

      addImage(formData)
        .then((res) => {
          console.log(res);
          that.dialogAddClient = false;
          that.getDeviceImages();
          that.$message({
            showClose: true,
            message: that.$t("tips.saveSuccess"),
            type: "success",
          });
        })
        .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });
    },
    update() {
      let that = this;
      this.headers = {
        "Content-Type": "multipart/form-data",
      };
      const formData = new FormData();
      formData.append("id", that.imageForm.id);
      formData.append("name", that.imageForm.name);
      formData.append("file", that.imageForm.file);
      formData.append("brandCode",that.imageForm.brandCode);
      updateImage(formData).then((res) => {
        console.log(res);
        that.$message({
          showClose: true,
          message: that.$t("tips.updateSuccess"),
          type: "success",
        });
        that.dialogEditClient = false;
        that.getDeviceImages();
        this.imageForm = {
          name: "",
          file: "",
          imageUrl: "",
          brandCode:"",
        };
      }) .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });;
    },
    deleteImage(e) {
      let that = this;
      let data = { id: e };
      deleteImage(data).then((res) => {
        that.$message({
          showClose: true,
          message: this.$t("tips.deleteSuccess"),
          type: "success",
        });
        that.getDeviceImages();
      }) .catch((err) => {
          that.$message({
            showClose: true,
            message: err.error.message,
            type: "error",
          });
        });;
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getDeviceImages();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getDeviceImages();
    },
     async getBrandInfos(){
      let that=this;
      let res = await getBrandInfos();
      let brandCode=localStorage.getItem("user_brand")?localStorage.getItem("user_brand"):"IR";
      that.brandInfo = res.result.find(x=>x.brandCode==brandCode);
    },
  },
};
</script>

<style scope>
.el-upload-list--picture .el-upload-list__item-thumbnail {
  height: 50px;
  width: 50px;
  margin-top: -7px;
  margin-left: -56px;
}
.el-upload-list--picture
  .el-upload-list__item.is-success
  .el-upload-list__item-name {
  line-height: 25px;
}
.el-upload-list--picture .el-upload-list__item {
  margin-top: 6px;
  padding: 6px 6px 6px 60px;
  height: 50px;
}
.el-upload__tip {
  line-height: 20px;
}
</style>
